import { render, staticRenderFns } from "./StatusCard.vue?vue&type=template&id=1c2229c6&scoped=true"
import script from "./StatusCard.vue?vue&type=script&lang=js"
export * from "./StatusCard.vue?vue&type=script&lang=js"
import style0 from "./StatusCard.vue?vue&type=style&index=0&id=1c2229c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2229c6",
  null
  
)

export default component.exports